import { render, staticRenderFns } from "./OrderCloning.vue?vue&type=template&id=31cc3532"
import script from "./OrderCloning.vue?vue&type=script&lang=js"
export * from "./OrderCloning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports